  export const parseMessages = (content: string) => {
  try {
    return JSON.parse(content);
  } catch {
    return content;
  }
};